import { memo } from "react";
import styled from "styled-components";
import DomainDetails from "types/domainDetails";

const Panel = styled.div`
  border-top: solid 1px #e8e8ef;
  margin: 20px -50px 0;
  padding: 30px 50px 0;
  @media only screen and (max-width: 992px) {
    margin-left: -20px;
    margin-right: -20px;
    margin-top: 10px;
    padding: 15px 0px;
  }

  h2 {
    margin-bottom: 35px;
    font-weight: 500;
    font-size: 1.5rem;
    display: block;

    @media only screen and (max-width: 992px) {
      padding-left: 20px;
      margin-bottom: 20px;
    }
  }
`;

var Content = styled.div`
  &:nth-child(even) {
    background-color: #f8f9fb;
  }

  strong {
    font-weight: 500;
    font-size: 1.2rem;
    display: block;
    margin-bottom: 0;
    margin-top: 0;
    padding: 20px 25px 15px;
  }

  span {
    display: block;
    border-bottom: solid 1px #e8e8ef;
    padding: 0 25px 20px;
  }
`;

var Contents = styled.div`
  border: solid 1px #e8e8ef;
  border-bottom: none;
  margin-bottom: 10px;

  @media only screen and (max-width: 992px) {
    margin: 0 20px -5px;
  }
`;

interface DomainPanelProps {
  title: string;
  details: Content[];
}

export interface Content {
  title: string;
  description: string;
}

const DomainPanel = (props: DomainPanelProps) => {
  const { title, details } = props;

  return (
    <Panel>
      <h2>{title}</h2>
      <Contents>
        {details.map((d) => (
          <Content>
            <strong>{d.title}</strong>
            <span>{d.description}</span>
          </Content>
        ))}
      </Contents>
    </Panel>
  );
};

export default memo(DomainPanel);
